import AddPumpingStation from "../components/PumpingStation/AddPumpingStation";

const AddPumpinghStationPage = () =>{
     
    return(
         
         <AddPumpingStation/>
    )
}

export default AddPumpinghStationPage;